import styled, { css } from 'styled-components';

const shared = (p) => css`
  width: ${p.isSmall ? p.theme.space[3] : p.theme.space[7]};
  height: ${p.isSmall ? p.theme.space[3] : p.theme.space[7]};
  border-radius: ${p.theme.radii.pill};
`;

export const StyledHolder = styled.div`
  ${(p) => shared(p)};

  background-color: ${(p) => p.theme.alias.shadow};
`;

export const StyledAvatar = styled.img`
  ${(p) => shared(p)};

  display: block;
  object-fit: cover;
`;
